<template>
  <div class="helpList" :style="'width:'+fullWidth  * 0.85 +'px;'">
    <div class="title">
      <el-collapse accordion  :style="'width:'+fullWidth * 0.85 +'px;'">
        <el-collapse-item v-for="help in helpList" :key="help.id" >
          <template slot="title">
            <div class="question">{{help.question}}</div>
          </template>
          <div v-html="help.answer" ></div>
        </el-collapse-item>
      </el-collapse>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeName: '1',
        fullWidth: document.documentElement.clientWidth,
        helpList:''
      }
    },
    mounted() {
      this.get_bodyWidth()
    },
    created() {
      this.loadData()
    },
    methods: {
      loadData() {
        console.log('加载数据')
        let that = this

        var requestUrl = '/score/web/_load_help_list.jsp'
        this.axios.get(requestUrl, {
            params: {}
          }).then(function(response) {
            that.helpList = response.data
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      get_bodyWidth() { //动态获取浏览器高度
        const that = this
        window.onresize = () => {
          return (() => {
            window.fullWidth = document.documentElement.clientWidth
            that.fullWidth = window.fullWidth
          })()
        }
      }
    },
    watch: {
      fullWidth(val) { //监控浏览器高度变化
        if (!this.timer) {
          this.fullWidth = val
          this.timer = true
          let that = this
          setTimeout(function() {
            that.timer = false
          }, 400)
        }

      }
    }
  }
</script>

<style>
  .helpList {
    margin: 20px;
  }

  .title {
    display: flex;
    justify-content: flex-start;
    font-size: 20px;
    font-weight: bold;
    word-break: break-all;
  }

  .question {

    font-size: 18px;
    font-weight: bold;

  }
</style>



// WEBPACK FOOTER //
// src/components/help.vue